import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  interval: undefined,
  open: false,
  title: '',
  timer: 0,
  showTimer: false,
  dispatch: undefined
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
